import { withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaHandlerProvider, IDomSelectors, BrowserWindow } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol, DomSelectorsSymbol } from '@wix/thunderbolt-symbols'

export type HandlerResponse = {
	top?: {
		height: number
		width: number
		top: number
		left: number
	}
}

export const GetAdsOnPageHandler = withDependencies(
	[DomSelectorsSymbol, BrowserWindowSymbol] as const,
	(domSelectors: IDomSelectors, window: BrowserWindow): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				getAdsOnPage(): HandlerResponse {
					const wixAdsElement = domSelectors.getByCompId('WIX_ADS', window!.document)
					if (!wixAdsElement) {
						return {}
					}

					const { height, width, x, y } = wixAdsElement.getBoundingClientRect()
					return {
						top: {
							height,
							width,
							top: y,
							left: x,
						},
					}
				},
			}
		},
	})
)
